import {ListItemIcon, ListItemText, MenuItem} from '@material-ui/core'
import useTriggerChild from 'modules/reports/hooks/trigger/child'
import React from 'react'
import {Link} from 'react-router-dom'
import useStyles from './ReportsMenuItem.styles'

type Props = {
  children: React.ReactNode
  danger?: boolean
  icon?: React.ReactElement
  onClick?: Function
  href?: string
  'data-testid': string
}

type ForwardedProps = {
  forwardedRef: React.Ref<any>
}

function ReportsMenuItem(props: Props & ForwardedProps) {
  const {children, danger, icon, href, onClick, forwardedRef} = props
  const {close} = useTriggerChild()
  const classes = useStyles()

  const statusClass = danger ? classes.danger : ''

  function handleClick() {
    close()
    if (onClick) onClick()
  }

  let linkComponent: any
  if (href) {
    linkComponent = React.forwardRef((menuItemProps: any, menuItemRef) => (
      <Link {...menuItemProps} ref={menuItemRef} to={href} />
    ))
  }

  return (
    <MenuItem
      className={statusClass}
      ref={forwardedRef}
      onClick={handleClick}
      component={linkComponent}
      dense
      data-testid={props['data-testid']}
    >
      {icon ? (
        <>
          <ListItemIcon className={statusClass}>{icon}</ListItemIcon>
          <ListItemText>{children}</ListItemText>
        </>
      ) : (
        children
      )}
    </MenuItem>
  )
}

export default React.forwardRef((props: Props, ref) => (
  <ReportsMenuItem {...props} forwardedRef={ref} />
))
